import React, { useEffect, useState } from 'react';
import logo from '../../images/logo.png';
import './Profile.css';
import { Link as Anchor } from 'react-router-dom';
import baseURL from '../url';
import { clienteFetch } from '../../utils/api';
import { useCliente } from '../../context/ClienteContext.jsx';
import ClienteAuthForm from '../ClienteAuth/ClienteAuthForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faLocationDot, faLock, faBoxOpen } from '@fortawesome/free-solid-svg-icons';
import moneda from '../moneda';

export default function Profile() {
    const { cliente, logout, setCliente } = useCliente();
    const [contactos, setContactos] = useState([]);

    // Secciones de edición
    const [seccion, setSeccion] = useState(null); // 'perfil' | 'direccion' | 'contrasena'

    // Campos perfil
    const [nombre, setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [telefono, setTelefono] = useState('');

    // Campos dirección predeterminada
    const [calle, setCalle] = useState('');
    const [colonia, setColonia] = useState('');
    const [ciudad, setCiudad] = useState('');
    const [cp, setCp] = useState('');
    const [referencias, setReferencias] = useState('');
    const [idDireccion, setIdDireccion] = useState(null);

    // Campos contraseña
    const [contrasenaActual, setContrasenaActual] = useState('');
    const [contrasenaNueva, setContrasenaNueva] = useState('');

    const [error, setError] = useState('');
    const [exito, setExito] = useState('');
    const [cargando, setCargando] = useState(false);

    // Pedidos del cliente
    const [pedidos, setPedidos] = useState([]);
    const [cargandoPedidos, setCargandoPedidos] = useState(false);

    useEffect(() => {
        fetch(`${baseURL}/api/contacto`, { method: 'GET' })
            .then(r => r.json())
            .then(data => setContactos(data.contacto?.reverse()[0] || []))
            .catch(() => {});
    }, []);

    const abrirSeccion = (s) => {
        setError(''); setExito('');
        if (s === 'perfil') {
            setNombre(cliente.nombre || '');
            setEmail(cliente.email || '');
            setTelefono(cliente.telefono || '');
        }
        if (s === 'direccion') {
            const dir = cliente.direcciones?.find(d => d.esPredeterminada == 1) || cliente.direcciones?.[0] || {};
            setIdDireccion(dir.idDireccion || null);
            setCalle(dir.calle || '');
            setColonia(dir.colonia || '');
            setCiudad(dir.ciudad || '');
            setCp(dir.codigoPostal || '');
            setReferencias(dir.referencias || '');
        }
        if (s === 'contrasena') {
            setContrasenaActual(''); setContrasenaNueva('');
        }
        if (s === 'pedidos' && seccion !== 'pedidos') {
            setCargandoPedidos(true);
            clienteFetch(`${baseURL}/api/cliente/pedidos`, { method: 'GET' })
                .then(r => r.json())
                .then(data => setPedidos(data.pedidos || []))
                .catch(() => setPedidos([]))
                .finally(() => setCargandoPedidos(false));
        }
        setSeccion(prev => prev === s ? null : s);
    };

    const guardarPerfil = async () => {
        setError(''); setExito(''); setCargando(true);
        try {
            const res = await clienteFetch(`${baseURL}/api/cliente/perfil`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ nombre, email, telefono }),
            });
            const data = await res.json();
            if (data.error) { setError(data.error); }
            else { setExito('Perfil actualizado'); setCliente(c => ({ ...c, ...data.cliente })); setSeccion(null); }
        } catch { setError('Error de conexión'); }
        finally { setCargando(false); }
    };

    const guardarDireccion = async () => {
        if (!calle.trim()) { setError('La calle es requerida'); return; }
        setError(''); setExito(''); setCargando(true);
        try {
            const body = { calle, colonia, ciudad, codigoPostal: cp, referencias, esPredeterminada: 1 };
            let res;
            if (idDireccion) {
                res = await clienteFetch(`${baseURL}/api/cliente/direcciones/${idDireccion}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body),
                });
            } else {
                res = await clienteFetch(`${baseURL}/api/cliente/direcciones`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body),
                });
            }
            const data = await res.json();
            if (data.error) { setError(data.error); }
            else { setExito('Dirección guardada'); setSeccion(null); }
        } catch { setError('Error de conexión'); }
        finally { setCargando(false); }
    };

    const guardarContrasena = async () => {
        if (!contrasenaActual || !contrasenaNueva) { setError('Completa ambos campos'); return; }
        setError(''); setExito(''); setCargando(true);
        try {
            const res = await clienteFetch(`${baseURL}/api/cliente/perfil`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ contrasenaActual, contrasenaNueva }),
            });
            const data = await res.json();
            if (data.error) { setError(data.error); }
            else { setExito('Contraseña actualizada'); setContrasenaActual(''); setContrasenaNueva(''); setSeccion(null); }
        } catch { setError('Error de conexión'); }
        finally { setCargando(false); }
    };

    return (
        <div className='profileContain'>
            <img src={logo} alt="logo" />

            {cliente ? (
                <>
                    <h2>Hola, {cliente.nombre || cliente.telefono}</h2>

                    {error  && <p style={{ color: '#e53e3e', fontSize: 13, margin: 0 }}>{error}</p>}
                    {exito  && <p style={{ color: '#38a169', fontSize: 13, margin: 0 }}>{exito}</p>}

                    <div className='profileText'>

                        {/* --- EDITAR PERFIL --- */}
                        <button className='profile-edit-toggle' onClick={() => abrirSeccion('perfil')}>
                            <FontAwesomeIcon icon={faPen} /> Editar datos personales
                        </button>
                        {seccion === 'perfil' && (
                            <div className='profile-edit-section'>
                                <input placeholder="Nombre" value={nombre} onChange={e => setNombre(e.target.value)} maxLength={100} />
                                <input placeholder="Email (opcional)" value={email} onChange={e => setEmail(e.target.value)} maxLength={100} />
                                <input placeholder="Teléfono" value={telefono} onChange={e => setTelefono(e.target.value)} maxLength={20} />
                                <button onClick={guardarPerfil} disabled={cargando} className='profile-save-btn'>
                                    {cargando ? 'Guardando...' : 'Guardar'}
                                </button>
                            </div>
                        )}

                        {/* --- EDITAR DIRECCIÓN --- */}
                        <button className='profile-edit-toggle' onClick={() => abrirSeccion('direccion')}>
                            <FontAwesomeIcon icon={faLocationDot} /> {idDireccion || (cliente.direcciones?.length > 0) ? 'Editar dirección de entrega' : 'Agregar dirección de entrega'}
                        </button>
                        {seccion === 'direccion' && (
                            <div className='profile-edit-section'>
                                <input placeholder="Calle y número *" value={calle} onChange={e => setCalle(e.target.value)} maxLength={255} />
                                <div className='profile-edit-row'>
                                    <input placeholder="Colonia" value={colonia} onChange={e => setColonia(e.target.value)} maxLength={100} />
                                    <input placeholder="C.P." value={cp} onChange={e => setCp(e.target.value)} maxLength={10} />
                                </div>
                                <input placeholder="Ciudad" value={ciudad} onChange={e => setCiudad(e.target.value)} maxLength={100} />
                                <input placeholder="Referencias (opcional)" value={referencias} onChange={e => setReferencias(e.target.value)} maxLength={255} />
                                <button onClick={guardarDireccion} disabled={cargando} className='profile-save-btn'>
                                    {cargando ? 'Guardando...' : 'Guardar dirección'}
                                </button>
                            </div>
                        )}

                        {/* --- MIS PEDIDOS --- */}
                        <button className='profile-edit-toggle' onClick={() => abrirSeccion('pedidos')}>
                            <FontAwesomeIcon icon={faBoxOpen} /> Mis pedidos
                        </button>
                        {seccion === 'pedidos' && (
                            <div className='profile-pedidos-section'>
                                {cargandoPedidos ? (
                                    <p className='profile-pedidos-empty'>Cargando...</p>
                                ) : pedidos.length === 0 ? (
                                    <p className='profile-pedidos-empty'>Aún no tienes pedidos registrados.</p>
                                ) : pedidos.map(p => (
                                    <div key={p.idPedido} className='profile-pedido-card'>
                                        <div className='profile-pedido-header'>
                                            <span className='profile-pedido-id'>#{p.idPedido}</span>
                                            <span className={`profile-pedido-estado profile-pedido-estado--${p.estado?.toLowerCase().replace(/\s/g, '-')}`}>
                                                {p.estado}
                                            </span>
                                            <span className='profile-pedido-fecha'>
                                                {p.createdAt?.split('T')[0] || p.createdAt}
                                            </span>
                                        </div>
                                        <div className='profile-pedido-productos'>
                                            {(p.productos || []).slice(0, 3).map((item, i) => (
                                                <span key={i} className='profile-pedido-item'>
                                                    {item.titulo} x{item.cantidad}
                                                </span>
                                            ))}
                                            {p.productos?.length > 3 && (
                                                <span className='profile-pedido-item profile-pedido-item--more'>
                                                    +{p.productos.length - 3} más
                                                </span>
                                            )}
                                        </div>
                                        <div className='profile-pedido-footer'>
                                            <span className='profile-pedido-total'>{moneda} {Number(p.total).toLocaleString()}</span>
                                            <span className='profile-pedido-pago'>{p.pago}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* --- CAMBIAR CONTRASEÑA --- */}
                        <button className='profile-edit-toggle' onClick={() => abrirSeccion('contrasena')}>
                            <FontAwesomeIcon icon={faLock} /> Cambiar contraseña
                        </button>
                        {seccion === 'contrasena' && (
                            <div className='profile-edit-section'>
                                <input type="password" placeholder="Contraseña actual" value={contrasenaActual} onChange={e => setContrasenaActual(e.target.value)} />
                                <input type="password" placeholder="Nueva contraseña" value={contrasenaNueva} onChange={e => setContrasenaNueva(e.target.value)} minLength={6} />
                                <button onClick={guardarContrasena} disabled={cargando} className='profile-save-btn'>
                                    {cargando ? 'Guardando...' : 'Cambiar contraseña'}
                                </button>
                            </div>
                        )}

                        <button onClick={logout} className='profile-logout-btn'>
                            Cerrar sesión
                        </button>
                    </div>
                </>
            ) : (
                <>
                    <h2>{contactos.nombre}</h2>
                    <div className='socials'>
                        {contactos.instagram && <Anchor to={contactos.instagram} target="_blank"><i className='fa fa-instagram'></i></Anchor>}
                        {contactos.telefono  && <Anchor to={`tel:${contactos.telefono}`} target="_blank"><i className='fa fa-whatsapp'></i></Anchor>}
                        {contactos.facebook  && <Anchor to={contactos.facebook} target="_blank"><i className='fa fa-facebook'></i></Anchor>}
                    </div>
                    <ClienteAuthForm />
                </>
            )}
        </div>
    );
}
